export default __webpack_public_path__ + "static/media/connectm-logo.67037240.svg";